import { createSelector } from '@reduxjs/toolkit';
import { getValue } from './common.selectors';

export const selectMapManagement = createSelector(
	getValue,
	state => state.mapManagement,
);

export const selectThemeList = createSelector(
	selectMapManagement,
	state => state.themeList,
);

export const selectThemeListForCompany = createSelector(
	selectThemeList,
	themeList => themeList?.filter(theme => !theme.userId),
);
